export default "__VITE_ASSET__C5fyOx0u__"